
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[market]/[language]/privacy-policy",
      function () {
        return require("private-next-pages/[market]/[language]/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[market]/[language]/privacy-policy"])
      });
    }
  